import React, {useEffect} from "react";
 
import {getSelfProfileInfo} from "../../../store/entities/Profile/Profile.actions";
import {useDispatch} from "react-redux";
import clsx from "clsx";
import Avatar from '@material-ui/core/Avatar';



const PaymentPeriodTable = ({ data = null }) => {
 
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getSelfProfileInfo())
  }, [])

  const getAbbreviation = (fullName) => {
    if (!fullName) {
      return '';
    }
    const arr = fullName.split(' ');
    if(arr.length >= 2) {
      const first = arr[0][0]?.toUpperCase() || '';
      const second = arr[1][0]?.toUpperCase() || '';
      return `${first} ${second}`;
    }
  }

  return (
    <div className={"paymentPeriodContainer"}>
      {  
        Object.keys(data).map((item, index) => (
          <div key={index} className={clsx("paymentPeriodContainer", "containerWrapper")}>
            <span className={"period EMPHASIS_SMALL"}>
              { item }
            </span>
            { data[item].map((payment, index) => (
              <div key={index} className={"payment"}>
                <div className={"paymentWrapper"}>
                  <div className={"innerContainer"}>
                    <div className={"userAvatar"}>
                      <Avatar className={"avatarTitle BODY_LARGE"}>
                        {getAbbreviation(payment.payerName)}
                      </Avatar>
                    </div>
                    <div className={"inputGroup"}>
                      {/*<span className={"username"}>Payment ID: {payment.name}</span>*/}
                      <span className={"username EMPHASIS_SMALL"}>{payment.payerName}</span>
                      <span className={"date BODY_SMALL"}>{payment.date}</span>
                    </div>
                  </div>
                  <span className={"amount EMPHASIS_MEDIUM"}>{payment.symbol}{payment.amount}</span>
                </div>
              </div>
            ))
            }
          </div>
        ))
      }
    </div>
  );
}

export default PaymentPeriodTable;
